// extracted by mini-css-extract-plugin
module.exports = {"paddedStepContainer":"Wizard_paddedStepContainer__2_z6E","step":"Wizard_step__2W5lt"};